import {css} from "@emotion/css";

export const commonStyles = {
  icon: css`
    margin-top: -2px;
  `,
};
